export function minLength(
  value: string | null | undefined,
  minLength: number
): boolean {
  return (
    value !== null && value !== undefined && value.trim().length >= minLength
  );
}
